import { TooltipText } from 'components/shared/TooltipText';
import React from 'react';
import { HeaderNode } from '../JsonContent';
import { JsonContentValidationMessage } from './JsonContentValidationMessage';

interface HeaderNodePorps extends HeaderNode {
  isZoomInActive?: boolean;
}

export const HeaderValueType: React.FunctionComponent<HeaderNodePorps> = (props): JSX.Element => {
  const isWrongValue = false;
  return (
    <div className={!props.isZoomInActive ? 'pt-2' : ''}>
      <div className={!props.isZoomInActive ? 'pt-2 pl-3 pr-3' : 'pt-3 pb-2 pl-3 pr-3'}>
        {!isWrongValue ? (
          <>
            <h5 className="wordBreak">{props.header}</h5>
            <span className="wordBreak">{props.value}</span>
          </>
        ) : (
          <JsonContentValidationMessage message={TooltipText.headerValueTypeValidationMessage} />
        )}
      </div>
    </div>
  );
};
